<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18UgFpy/images/cover.jpg?1700511391734" alt="This image is the cover for the book Death March Through Russia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death March Through Russia
      </h1>
      <p class="bookDescription body article font2">
        <b>This World War II memoir by a Nazi soldier details his unimaginable experience as a German prisoner-of-war in the Soviet Union.</b><br/>  <br/> Lothar Hermann grew up in Bavaria, going through the RAD (Nazi Labor Service) before being conscripted into a Wehrmacht Mountain Division (the Gebirgsdivision) in 1940. He participated in Germany’s advance through southern Ukraine in 1941 and, in 1944, was arrested in Romania while retreating to Germany. The Romanians passed him onto the Soviets, who placed him in a forced labor camp, where he watched two-thirds of prisoners around him die. In 1949, Herrmann was finally released to Germany and returned to Bavaria.<br/>  <br/> Three million German troops were taken prisoner by the Red Army and around two-thirds of them survived to return to Germany in 1949 like Hermann, but their stories are little known. Klaus Willmann draws on interviews he conducted with Herrmann, to recount these astonishing recollections in the first-person. Depicting the challenges of growing up in Nazi Bavaria to becoming a Soviet prisoner-of-war, this is a gripping and enlightening account from a necessary but rarely explored perspective.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Klaus Willmann, Roger Moorhouse
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Greenhill Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ab1b1db